<template>
  <div class="c endpoint-side-panel" :class="{'is-open': open}">
    <div class="sidepanel">
      <div v-if="endpointDetail !== null">
        <v-layout column>
          <v-tabs
            v-model="tab"
            color="white"
            grow
          >
            <v-tabs-slider color="primary" />
            <v-tab>
              Daten
            </v-tab>
            <v-tab>
              Ereignisse
            </v-tab>
          </v-tabs>

          <div v-if="tab === 0">
            <trafostation
              v-for="(item, index) in trafostationen"
              :key="index"
              :endpoint="item"
            />
            <v-layout
              justify-center
              row
              wrap
              align-space-around
            >
              <abgangsfeld
                v-for="(item, index) in abgangsfelder"
                :key="index"
                :endpoint="item"
              />
            </v-layout>

            <v-layout
              justify-center
              row
              wrap
              align-space-around
            >
              <kabelverteiler
                v-for="(item, index) in kabelverteiler"
                :key="index"
                :endpoint="item"
              />
            </v-layout>
          </div>

          <div v-if="tab === 1 && endpointsWithEvents !== null">
            <events
              v-for="(item, index) in endpointsWithEvents"
              :key="index"
              :endpoint="item"
              :endpoint-id="index"
              :parent-endpoint="parentEndpoint"
            />
          </div>
          <div v-if="endpointsWithEvents.length < 1 && tab === 1">
            <v-card light>
              <v-card-title>
                <div>
                  <span class="black--text title">
                    {{ endpoint.label }} / {{ endpoint.ms_link_number }}
                  </span><br>
                  <span class="green--text">Keine Ereignisse für diesen Endpunkt</span>
                </div>
              </v-card-title>
              <v-card-text>
                <v-img src="/images/no_events.png" />
              </v-card-text>
            </v-card>
          </div>
        </v-layout>
      </div>
    </div>
    <div class="backdrop" @click="toggle" />
  </div>
</template>

<script>
import Trafostation from './Endpoints/Trafostation.vue';
import Abgangsfeld from './Endpoints/Abgangsfeld.vue';
import Events from './Endpoints/Events.vue';
import Kabelverteiler from './Endpoints/Kabelverteiler.vue';

export default {
  name: 'EndpointSidePanel',
  components: {
    Trafostation,
    Abgangsfeld,
    Events,
    Kabelverteiler,
  },
  props: {
    endpoint: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      open: false,
      tab: 0,
      showEvents: true,
      showDetails: true,
      parentEndpoint: null,
    };
  },
  computed: {
    endpointsWithEvents() {
      if (Array.isArray(this.endpointDetail)) {
        const endpointsWithEvents = this.endpointDetail.filter((endpoint) => {
          return endpoint.events.length > 0;
        });
        return endpointsWithEvents;
      }
      return [];
    },
    trafostationen() {
      if (Array.isArray(this.endpointDetail)) {
        const trafostationen = this.endpointDetail.filter((endpoint) => { return endpoint.type === 'Trafostation'; });
        return trafostationen;
      }
      return [];
    },
    abgangsfelder() {
      if (Array.isArray(this.endpointDetail)) {
        const abgangsfelder = this.endpointDetail.filter((endpoint) => { return endpoint.type === 'Abgangsfeld'; });
        return abgangsfelder;
      }
      return [];
    },
    kabelverteiler() {
      if (Array.isArray(this.endpointDetail)) {
        const kabelverteiler = this.endpointDetail.filter((endpoint) => { return endpoint.type === 'KVS'; });
        return kabelverteiler;
      }
      return [];
    },
    endpointDetail() {
      return this.$store.state.gridAreas.endpointDetail;
    },
    deviceCount() {
      return this.endpoint.device;
    },
  },
  updated() {
    this.parentEndpoint = this.endpoint;
  },
  methods: {
    border(endpoint) {
      return {
        border: `2px solid ${endpoint.color_code}`,
        margin: '10px',
        padding: '10px',
      };
    },
    toggle() {
      this.open = !this.open;
      if (this.open === false) {
        this.$store.state.gridAreas.endpointDetail = null;
      }
    },
    reloadDevice() {
      this.$store.dispatch('GET_ALL_DEVICES', true);
      this.showDetails = false;
      setTimeout(() => {
        this.showDetails = true;
      }, 500);
    },
  },
};
</script>
